import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { FormInput } from '../Form/FormInput';

interface Props {
  name: string;
  ico: string;
  dic: string;
  icdph: string;
  onChange: (e) => void;
}

function CompanyInfo({ name, ico, dic, icdph, onChange }: Props) {
  return (
    <Wrapper>
      <FormInput
        name={'company'}
        type="text"
        label={'Firma'}
        value={name}
        required={true}
        onChange={onChange}
      />
      <FormInput
        name={'ico'}
        type="text"
        required={true}
        label={'IČO'}
        value={ico}
        onChange={onChange}
      />
      <FormInput
        name={'dic'}
        type="text"
        required={true}
        label={'DIČ'}
        value={dic}
        onChange={onChange}
      />
      <FormInput
        name={'icdph'}
        type="text"
        required={true}
        label={'IČ DPH'}
        value={icdph}
        marginBottom={0}
        onChange={onChange}
      />
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  padding: ${rem(42)} ${rem(32)} ${rem(32)};

  ${({ theme }) => theme.mediab.m600`
    padding: ${rem(42)} ${rem(16)} ${rem(32)};
  `}
`;

export { CompanyInfo };
